import { gql } from '@apollo/client';

export const CREATE_PAYMENT_HOLD = gql`
  mutation Flex_CreatePaymentHold($input: CreateTemporaryPaymentHoldInput!) {
    createTemporaryPaymentHold(input: $input) {
      result
      message
    }
  }
`;
